import { Link } from 'react-router-dom';

const SafetySection = () => {
  const safetyFeatures = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Student Verification',
      description: 'All users verified with .edu email addresses and student IDs'
    },
    {
      icon: 'ri-map-pin-fill',
      title: 'Safe Meeting Spots',
      description: 'Recommended public, well-lit campus locations for all transactions'
    },
    {
      icon: 'ri-star-fill',
      title: 'Rating System',
      description: 'Comprehensive seller ratings and transaction history tracking'
    },
    {
      icon: 'ri-customer-service-fill',
      title: '24/7 Monitoring',
      description: 'Our team continuously monitors the platform for suspicious activity'
    }
  ];

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-green-500/20 text-green-400 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-shield-check-fill"></i>
              <span>Safety First</span>
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Trade with Complete Confidence
            </h2>
            
            <p className="text-xl text-gray-300 mb-8">
              Campus Market prioritizes your safety with student verification,
              secure meeting recommendations, and continuous monitoring.
            </p>
            
            <div className="space-y-6">
              {safetyFeatures.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-green-400`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-8">
              <Link
                to="/marketplace"
                className="inline-flex items-center px-6 py-3 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Start Trading Safely
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Safety Score</h3>
                <div className="text-3xl font-bold text-green-400">4.9/5.0</div>
              </div>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Verified Students</span>
                  <span className="text-white font-semibold">98.5%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Safe Transactions</span>
                  <span className="text-white font-semibold">99.2%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Response Time</span>
                  <span className="text-white font-semibold">&lt; 2 min</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Platform Monitoring</span>
                  <span className="text-green-400 font-semibold">24/7 Active</span>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 bg-green-400 text-green-900 px-3 py-1 rounded-full text-sm font-medium">
              Trusted Platform
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafetySection;